import React from 'react';
import { connect } from 'react-redux';

import { DataLoader } from '../../components/common';
import { getLiveStreamsData as getLiveStreamsDataAction } from '../../redux/actions/router';
import { LiveStreamsContainer } from './live-streams.lazy';

interface Props {
  router: any;
  getLiveStreamsData(router: any): Promise<any>;
}

class LiveStreamsDataLoader extends React.Component<Props> {
  private loadData(): Promise<any> {
    const { getLiveStreamsData, router } = this.props;

    return getLiveStreamsData(router);
  }

  public render() {
    return (
      <DataLoader loadData={this.loadData.bind(this)}>
        {(props) => <LiveStreamsContainer {...props} />}
      </DataLoader>
    );
  }
}

const mapStateToProps = null;

const mapDispatchToProps = {
  getLiveStreamsData: getLiveStreamsDataAction,
};

export const LiveStreams = connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(LiveStreamsDataLoader);
